import React, { useCallback, useMemo } from 'react'
import { FeatureCollection } from 'geojson'
import mapboxgl from 'mapbox-gl'
import Map from '~/components/map/map'
import GeoJSON from '~/components/map/geoJson'
import { FeatureWithInfoAndStyle } from '../../statsAndGeoToFeatureCollection.util'
import { ItineraryInfoWindow } from './ItineraryInfoWindow.component'
import { fetchMapPosition } from './utils'

/**
 * Componente de itinerário, plotando em mapa as informações da featureCollection.
 */
export const ItineraryMap = ({
  itinerary,
}: {
  /**FeatureCollection completa do itinerário */
  itinerary: FeatureCollection
}) => {
  const infoWindows = useMemo(() => {
    if (itinerary) {
      return ({ feature }: { feature: FeatureWithInfoAndStyle }): JSX.Element => (
        <ItineraryInfoWindow feature={feature} maxHeight={'150px'} />
      )
    } else {
      return undefined
    }
  }, [itinerary])

  const handleFeatureClick = useCallback(
    (event: mapboxgl.MapMouseEvent & mapboxgl.MapDataEvent) => {
      const map = event.target as mapboxgl.Map
      const currentZoom = map.getZoom()

      map.easeTo({
        center: event.lngLat,
        zoom: currentZoom + 0.0001,
        duration: 0,
      })
    },
    [],
  )

  return (
    <Map
      mapProvider={'mapbox'}
      {...fetchMapPosition(itinerary)}
      mapType={'roadmap'}
      tilt={0}
      is3D={false}
    >
      <GeoJSON
        geoJson={itinerary as any}
        idPropertyName='geoId'
        renderInfoWindow={infoWindows}
        onClick={handleFeatureClick}
      />
    </Map>
  )
}
